module.exports = __webpack_public_path__ + "static/githyanki_supreme_commander-75ef96ef1c0745d17ca68de1d8c8a6d7.png";